import { createEntityQueryKeys } from '@/shared/lib'

const root = createEntityQueryKeys(['account'])

export const accountKeys = {
  ...root,
  current: () => [...root.all, 'current'] as const
}
